import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'

import cls from './title-panel.module.scss'

type TitlePanelProps = {
	title: string
	productCount: number
	isLoading: boolean
	/**
	 * Куда помещать счётчик товаров относительно заголовка:
	 * false (по умолчанию) — отдельным span рядом с <h1> (текст <h1> = только title);
	 * true — внутрь <h1> (текст <h1> = title + « - N»).
	 * Влияет на содержимое <h1> (SEO), поэтому задаётся разделом явно.
	 */
	countInTitle?: boolean
}

export const TitlePanel = (props: TitlePanelProps) => {
	const { title, productCount, isLoading, countInTitle = false } = props

	if (isLoading) {
		return (
			<div className={cls.root}>
				<SkeletonLoader width={350} height={34} />
			</div>
		)
	}

	if (countInTitle) {
		return (
			<div className={cls.root}>
				<h1 className={cls.title}>
					{title}
					{!!productCount && <span className={cls.countInline}>{` - ` + productCount}</span>}
				</h1>
			</div>
		)
	}

	return (
		<div className={cls.root}>
			<h1 className={cls.title}>{title}</h1>
			{!!productCount && <span className={cls.count}>{` - ` + productCount}</span>}
		</div>
	)
}
